import { useNavigate } from 'react-router';
import { Topbar } from '../components/chrome/Topbar.js';
import { Btn } from '../components/chrome/Buttons.js';

export function Collection() {
  const nav = useNavigate();
  return (
    <div className="fade-in" style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      <Topbar title="Collection" />
      <div className="placeholder-shell">
        <h1>COMING SOON</h1>
        <p>Full collection grid drops in Plan 3.</p>
        <Btn variant="primary" onClick={() => nav('/menu')}>BACK TO MENU</Btn>
      </div>
    </div>
  );
}
